import { useTranslation } from 'react-i18next';
import type { RuleId } from '@/rule/domain/RuleId.ts';

export const useRuleIdText = (id: RuleId): string => {
  const { t } = useTranslation('rule');

  return t('rule.id', { id: id.value });
};
